<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='600px')
        template(v-slot:activator='{ on }')
            v-btn(icon light v-on='on')
                v-icon mdi-trash-can-outline
        v-card
            v-card-title
                span.text-h5 Remove Phone Number
            v-card-text
                v-container
                    span.text-h6 Are you sure you want to delete this phone number?

                v-container
                    span {{ phoneNumber | tel }}

            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                        v-icon mdi-window-close
                        | Close
                    v-btn.ma-2(color="red" outlined ripple :disabled="!(customerPhoneNumberId > 0)" @click='handleDestroyCustomerPhoneNumber(); dialog = false;')
                        v-icon mdi-content-save
                        | Delete

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                dialog: false,
            }
        },
        methods: {
            handleDestroyCustomerPhoneNumber() {

                const options = {
                    customer_phone_number_id: this.customerPhoneNumberId,
                }

                // Return if not valid options
                if (!(this.customerPhoneNumberId > 0)) {
                    return;
                }

                this.destroyCustomerPhoneNumber(options);
            },
        },
        computed: {
        },
        components: {
        },
        props: {
            customerPhoneNumberId: Number,
            phoneNumber: String,
            destroyCustomerPhoneNumber: Function,
        },
        created() {
            return;
        },
    });
</script>

<style lang="scss" scoped>
</style>